var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_994_123184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4139 7.91485C28.4139 6.7863 27.4992 5.875 26.3748 5.875C25.2504 5.875 24.335 6.7863 24.335 7.91485C24.335 9.03927 25.2504 9.95052 26.3748 9.95052C27.4992 9.95052 28.4139 9.03927 28.4139 7.91485Z",
    fill: "url(#paint0_linear_994_123184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1309 23.8388C31.0554 25.4944 30.7785 26.3939 30.5487 26.9913C30.2398 27.7834 29.8715 28.3499 29.274 28.9439C28.6833 29.538 28.1169 29.9055 27.3248 30.2109C26.7274 30.4442 25.8245 30.722 24.169 30.8008C22.3792 30.8797 21.8489 30.8965 17.3102 30.8965C12.7757 30.8965 12.2411 30.8797 10.4514 30.8008C8.79587 30.722 7.89716 30.4442 7.29968 30.2109C6.50339 29.9055 5.94122 29.538 5.34714 28.9439C4.74884 28.3499 4.3805 27.7834 4.0759 26.9913C3.84594 26.3939 3.56489 25.4944 3.49352 23.8388C3.4063 22.049 3.39032 21.5103 3.39032 16.9809C3.39032 12.4422 3.4063 11.9077 3.49352 10.1178C3.56489 8.46233 3.84594 7.56369 4.0759 6.96117C4.3805 6.1699 4.74884 5.60685 5.34714 5.01276C5.94122 4.41956 6.50339 4.05116 7.29968 3.74241C7.89716 3.5083 8.79587 3.23473 10.4514 3.15588C12.2411 3.07696 12.7757 3.05682 17.3102 3.05682C21.8489 3.05682 22.3792 3.07696 24.169 3.15588C25.8245 3.23473 26.7274 3.5083 27.3248 3.74241C28.1169 4.05116 28.6833 4.41956 29.274 5.01276C29.8715 5.60685 30.2398 6.1699 30.5487 6.96117C30.7785 7.56369 31.0554 8.46233 31.1309 10.1178C31.214 11.9077 31.2341 12.4422 31.2341 16.9809C31.2341 21.5103 31.214 22.049 31.1309 23.8388ZM34.1878 9.97858C34.1048 8.16945 33.8194 6.93348 33.3957 5.85694C32.9645 4.74008 32.3863 3.79357 31.4397 2.84706C30.4975 1.90478 29.551 1.32662 28.4341 0.890307C27.3534 0.470737 26.1215 0.182064 24.3116 0.103211C22.5016 0.0159229 21.9236 0 17.3102 0C12.701 0 12.1187 0.0159229 10.3087 0.103211C8.50298 0.182064 7.27198 0.470737 6.18622 0.890307C5.07357 1.32662 4.12707 1.90478 3.18478 2.84706C2.23827 3.79357 1.66011 4.74008 1.22462 5.85694C0.805049 6.93348 0.519776 8.16945 0.432489 9.97858C0.353634 11.7885 0.333496 12.3675 0.333496 16.9809C0.333496 21.5901 0.353634 22.1682 0.432489 23.9781C0.519776 25.7839 0.805049 27.019 1.22462 28.1006C1.66011 29.2133 2.23827 30.164 3.18478 31.1063C4.12707 32.0486 5.07357 32.6309 6.18622 33.0664C7.27198 33.486 8.50298 33.7713 10.3087 33.8544C12.1187 33.9374 12.701 33.9576 17.3102 33.9576C21.9236 33.9576 22.5016 33.9374 24.3116 33.8544C26.1215 33.7713 27.3534 33.486 28.4341 33.0664C29.551 32.6309 30.4975 32.0486 31.4397 31.1063C32.3863 30.164 32.9645 29.2133 33.3957 28.1006C33.8194 27.019 34.1048 25.7839 34.1878 23.9781C34.2709 22.1682 34.291 21.5901 34.291 16.9809C34.291 12.3675 34.2709 11.7885 34.1878 9.97858Z",
    fill: "url(#paint1_linear_994_123184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3104 22.6347C14.1865 22.6347 11.6515 20.1039 11.6515 16.9799C11.6515 13.8509 14.1865 11.3169 17.3104 11.3169C20.4353 11.3169 22.9735 13.8509 22.9735 16.9799C22.9735 20.1039 20.4353 22.6347 17.3104 22.6347ZM17.3104 8.25586C12.4949 8.25586 8.59473 12.1643 8.59473 16.9799C8.59473 21.7914 12.4949 25.6957 17.3104 25.6957C22.126 25.6957 26.0304 21.7914 26.0304 16.9799C26.0304 12.1643 22.126 8.25586 17.3104 8.25586Z",
    fill: "url(#paint2_linear_994_123184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_994_123184",
    x1: 0.639658,
    y1: 33.6052,
    x2: 31.4626,
    y2: 2.78239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_994_123184",
    x1: 0.639788,
    y1: 33.6488,
    x2: 31.4881,
    y2: 2.80051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_994_123184",
    x1: 0.648066,
    y1: 33.6486,
    x2: 31.4889,
    y2: 2.80784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_994_123184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIntIcon);
export default __webpack_public_path__ + "static/media/insta_int_icon.c32556e2dd3c3a8e34204e3612016257.svg";
export { ForwardRef as ReactComponent };